import React from "react";
import { ExternalLink } from "lucide-react";

// Import your PDF files directly
import Mou1PDF from "../../assets/MouPdf/Mou1.pdf";
import Mou2PDF from "../../assets/MouPdf/Mou2.pdf";
import Mou3PDF from "../../assets/MouPdf/Mou3.pdf";
import Mou4PDF from "../../assets/MouPdf/Mou4.pdf";

const MouPdf = () => {
  // PDF data with direct imports
  const pdfFiles = [
    {
      id: 1,
      name: "Mou Document 1",
      pdfFile: Mou1PDF,
    },
    {
      id: 2,
      name: "Mou Document 2",
      pdfFile: Mou2PDF,
    },
    {
      id: 3,
      name: "Mou Document 3",
      pdfFile: Mou3PDF,
    },
    {
      id: 4,
      name: "Mou Document 4",
      pdfFile: Mou4PDF,
    },
  ];

  // Function to open PDF in new tab
  const openPdfInNewTab = (pdfFile) => {
    window.open(pdfFile, "_blank");
  };

  return (
    <div className="flex flex-col bg-gray-100 p-6">
      <h1 className="text-2xl font-bold mb-6 text-center">MOU Documents</h1>

      <div className="bg-teal-500 shadow-md  rounded-md overflow-hidden">
        <div className="border-b">
          {pdfFiles.map((pdf, index) => (
            <div
              key={pdf.id}
              className={`flex justify-start items-center px-6 py-4 ${
                index < pdfFiles.length - 1 ? "border-b border-gray-200" : ""
              }`}
            >
              <h2 className="font-medium text-white items-start ">{pdf.name}</h2>
              <button
                onClick={() => openPdfInNewTab(pdf.pdfFile)}
                className="bg-white  text-teal-500 py-2 px-4 rounded-md flex items-center hover:bg-teal-600 transition-colors"
                aria-label={`View ${pdf.name}`}
              >
                <ExternalLink size={16} className="mr-2" />
                View
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MouPdf;
